<template>
  <div class="personal-task">
    <div class="list-task-item" :class="{'task-complete':isCompete(item.task_stage),'check-active':check == item.id}" v-for="(item,index) in dataset" :key="item.id" @click="openDetail(index)">
      <!-- <div class="dot" v-if="item.todo_mobile_history && item.todo_mobile_history.length > 0">
        <div style="width:6px;height:6px;"></div>
      </div> -->
      <div class="left">
        <div v-if="!onlyReal">
          <el-checkbox class="list-checkbox" @change="taskStatusChange(item,index,isCompete(item.task_stage))" :value="isCompete(item.task_stage)"></el-checkbox>
        </div>
        <toolTip class="task-name" style="width:50%" :title="item.task_name" @click.native="taskClick(item)">
          <span>{{item.task_name}}</span>
        </toolTip>
      </div>
      <div class="right">
        <div class="title" @click="projectClick(item)">
          <i class="icon iconfont iconicon_action_item_nor"></i>
          <toolTip class="task-name" style="width:100%" :title="item.project.title">
            <span>{{item.project.title}}</span>
          </toolTip>
        </div>
        <div class="time">{{item.end_time ? item.end_time.replace(/-/g,'/'):''}}</div>
      </div>
    </div>
    <div v-if="!finish" class="loading-box" @click="loadMore">
      <i v-if="loading" class="el-icon-loading"></i>
      <div v-else>
        <span>查看更多</span>
        <i class="icon iconfont iconicon_arrow_task"></i>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/services/api/mine/mine'
export default {
  props: ['dataset', 'finish', 'load', 'onlyReal', 'check'],
  components: {
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    isCompete() {
      return task_stage => {
        return task_stage === '已完成' ? true : false
      }
    }
  },
  mounted() {
    console.log(this.onlyReal)
  },
  methods: {
    taskStatusChange(item, index, isCompete) {
      this.$emit('taskStatusChange', { item, index, isCompete })
    },
    colorChange(item, index) {
      this.$emit('colorChange', { item, index })
    },
    timeChange(item, index) {
      this.$emit('timeChange', { item, index })
    },
    openDetail(index) {
      this.dataset[index].todo_mobile_history = []
      this.$emit('openDetail', this.dataset[index].id)
    },
    loadMore() {
      this.loading = true
      this.load(res => {
        this.loading = false
      })
    },
    taskClick(item) {
      this.$emit('taskClick', { task_id: item.id, task_list_id: item.task_list_id })
    },
    projectClick({ project_id }) {
      this.$emit('projectClick', project_id)
    }
  }
}
</script>
<style lang="scss">
.personal-task {
  padding-bottom: 11px;
  .check-active {
    background-color: #eaebec !important;
  }
  .loading-box {
    padding-left: 24px;
    font-size: 14px;
    color: rgba(32, 32, 32, 0.6);
    padding-top: 16px;
    padding-bottom: 16px;
    padding: 16px 24px;
    i {
      font-size: 14px;
      margin-left: 4px;
    }
    > div {
      cursor: pointer;
      display: inline-block;
      &:hover {
        color: #2682ff;
      }
      &:active {
        color: #0463d6;
      }
    }
  }
  .list-task-item {
    height: 48px;
    line-height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    border-bottom: 1px solid rgba(32, 32, 32, 0.08);
    padding-left: 24px;
    &:hover {
      background-color: #f7f8f9;
    }
    &:active {
      background-color: #eaebec;
    }
    .left {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: initial;
      width: 60%;
      .task-name {
        cursor: pointer;
        &:hover {
          color: $color-active;
        }
      }
      > span {
        margin-left: 8px;
      }
      .list-checkbox {
        margin-right: 8px;
      }
    }
    .right {
      display: flex;
      align-items: center;
      width: 30%;
      justify-content: space-between;
      font-size: 14px;
      color: rgba(32, 32, 32, 0.6);
      padding-right: 24px;
      .title {
        display: flex;
        align-items: center;
        margin-right: 10%;
        cursor: pointer;
        width: 0;
        flex: 1;
        i {
          margin-right: 8px;
          font-size: 14px;
        }
        &:hover {
          color: $color-active;
        }
      }
    }
    .dot {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: linear-gradient(225deg, #6b97cf 0%, #456fb3 100%);
      flex-shrink: 0;
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
      left: 28px;
      z-index: 1;
    }
  }
  .task-complete {
    > *:not(.left) {
      opacity: 0.4;
    }
    .left {
      .tool-tip {
        opacity: 0.4;
      }
    }
  }
}
</style>
